import StatsContainer from "./StatsMobileAppContainer";
import StatsStore from "./StatsMobileAppStore";

export default StatsStore(StatsContainer);